import {ReactComponent as ArrowIcon} from './arrow.svg'

function Arrow() {
  return <ArrowIcon />
}

export default Arrow
